export const handleServiceParams = state => {
  const serviceParams = {
    plate: state.plate,
    model_year: state.year,
    model_car: state.model_car,
    date: state.date,
    km: state.km,
  };

  return serviceParams;
};
